import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import {NumberBox as DXNumberBox} from 'devextreme-react';


export default class NumberBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            disabled: props.disabled,
        };

        this.onValueChanged = this.onValueChanged.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            value: props.value,
            disabled: props.disabled,
        });
    }

    onValueChanged(e) {
        const {setProps} = this.props;
        if (setProps) {
            setProps({
                value: e.value,
                valueChanged: {value: e.value, previousValue: e.previousValue, timestamp: Date.now()}
            });
        }
        this.setState({value: e.value});
    }

    render() {
        return (
            <DXNumberBox
                {...R.omit(['setProps'], this.props)}
                value={this.state.value}
                disabled={this.state.disabled}
                onValueChanged={this.props.onValueChanged || this.onValueChanged}
            />
        );
    }
}

NumberBox.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,
    /**
     * A collection of an node's child elements
     */
    children: PropTypes.node,

    accessKey: PropTypes.string,
    activeStateEnabled: PropTypes.bool,
    buttons: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
    disabled: PropTypes.bool,
    elementAttr: PropTypes.object,
    focusStateEnabled: PropTypes.bool,
    format: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    hint: PropTypes.string,
    hoverStateEnabled: PropTypes.bool,
    inputAttr: PropTypes.object,
    invalidValueMessage: PropTypes.string,
    isValid: PropTypes.bool,
    max: PropTypes.number,
    min: PropTypes.number,
    mode: PropTypes.oneOf(['number', 'text', 'tel']),
    name: PropTypes.string,
    onChange: PropTypes.func,
    onContentReady: PropTypes.func,
    onCopy: PropTypes.func,
    onCut: PropTypes.func,
    onDisposing: PropTypes.func,
    onEnterKey: PropTypes.func,
    onFocusIn: PropTypes.func,
    onFocusOut: PropTypes.func,
    onInitialized: PropTypes.func,
    onInput: PropTypes.func,
    onKeyDown: PropTypes.func,
    onKeyUp: PropTypes.func,
    onOptionChanged: PropTypes.func,
    onPaste: PropTypes.func,
    onValueChanged: PropTypes.func,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    rtlEnabled: PropTypes.bool,
    showClearButton: PropTypes.bool,
    showSpinButtons: PropTypes.bool,
    step: PropTypes.number,
    stylingMode: PropTypes.oneOf(['outlined', 'underlined', 'filled']),
    tabIndex: PropTypes.number,
    text: PropTypes.string,
    useLargeSpinButtons: PropTypes.bool,
    validationError: PropTypes.object,
    validationErrors: PropTypes.arrayOf(PropTypes.object),
    validationMessageMode: PropTypes.oneOf(['always', 'auto']),
    validationStatus: PropTypes.oneOf(['valid', 'invalid', 'pending' ]),
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
    valueChangeEvent: PropTypes.string,
    /**
     * Dash event
     */
    valueChanged: PropTypes.object,
    visible: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func,
    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};

NumberBox.defaultProps = {
    accessKey: null,
    activeStateEnabled: true,
    // buttons: undefined,
    disabled: false,
    elementAttr: {},
    focusStateEnabled: true,
    format: '',
    // height: undefined,
    // hint: undefined,
    hoverStateEnabled: true,
    inputAttr: {},
    invalidValueMessage: 'Value must be a number' ,
    isValid: true,
    // max: undefined,
    // min: undefined,
    mode: 'number',
    name: '',
    onChange: null,
    onContentReady: null,
    onCopy: null,
    onCut: null,
    onDisposing: null,
    onEnterKey: null,
    onFocusIn: null,
    onFocusOut: null,
    onInitialized: null,
    onInput: null,
    onKeyDown: null,
    onKeyUp: null,
    onOptionChanged: null,
    onPaste: null,
    onValueChanged: null,
    placeholder: '',
    readOnly: false,
    rtlEnabled: false,
    showClearButton: false,
    showSpinButtons: false,
    step: 1,
    stylingMode: 'outlined', // 'underlined' (Material)
    tabIndex: 0,
    // text: // read-only
    useLargeSpinButtons: false, // true, false (desktop)
    validationError: null,
    validationErrors: null,
    validationMessageMode: 'auto',
    validationStatus: 'valid',
    value: 0,
    valueChangeEvent: 'change',
    visible: true,
    // width: undefined
};
